/**
 * Type guard to check if the given handler is an instance of AnyApiHandler.
 * @param handler The handler to check.
 */
export const isAnyApiHandler = (handler) => {
    if (typeof handler !== "object" || handler === null) {
        return false;
    }
    return ["find_once", "find", "save", "delete", "validate"].every((methodKey) => typeof handler[methodKey] === "function");
};
/**
 * Type guard to check if the given handler is an instance of AnyNestedHandler.
 * @param handler The handler to check.
 */
export const isAnyNestedHandler = (handler) => {
    if (typeof handler !== "object" || handler === null) {
        return false;
    }
    return ["find_once", "find", "merge", "delete", "validate", "getKeyToPutParentOn"].every((methodKey) => typeof handler[methodKey] === "function");
};
//# sourceMappingURL=type-utils.js.map